import TripList from './tripList';
export default TripList;